import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import RSVP from 'rsvp';

class BacklogInitiativesInitiativeArtifactsRoute extends Route {
  @service store;

  model() {
    return RSVP.hash({
      initiative: this.modelFor('backlog.initiatives.initiative'),
      artifacts: this.store.query('artifact', {
        filter: {
          initiative: this.modelFor('backlog.initiatives.initiative').id,
        },
      }),
    });
  }
}

export default instrumentRoutePerformance(
  BacklogInitiativesInitiativeArtifactsRoute,
);
